import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { LanguageService } from 'src/app/services/language.service';
import { ThemeService } from 'src/app/services/theme.service';
import { Security } from 'src/app/utils/security.util';
import { ModalChangePasswordComponent } from '../modal-change-password/modal-change-password.component';

@Component({
  selector: 'app-modal-settings',
  templateUrl: './modal-settings.component.html',
  styleUrls: ['./modal-settings.component.scss'],
})
export class ModalSettingsComponent implements OnInit {

  darkModel;
  languages = [];
  lang;

  constructor(private themeService: ThemeService, private modalCrtl: ModalController, private navCtrl: NavController,
                    private languageService: LanguageService) { }

  ngOnInit() {
    if (Security.getChangeTheme() === 'true') {
      this.darkModel = true;
    } else {
      this.darkModel = false;
    }

    this.lang = Security.getLanguage();

    this.loadLanguages();
  }
  onChangeTheme(event) {
    this.themeService.setAppTheme(event.target.checked);
    this.darkModel = event.target.checked;
  }

  async showModalChangePassword() {
    const modal = await this.modalCrtl.create({
      component: ModalChangePasswordComponent
    });

    modal.onDidDismiss().then(() => {
      this.close();
    });

    modal.present();
  }

  close() {
    this.modalCrtl.dismiss();
  }

  loadLanguages(){
    this.languages = this.languageService.getLanguages();
  }

  changeLanguage(event){
    this.lang = event;
    this.languageService.setLanguage(this.lang);
  }

  logout() {
    Security.clear();
    this.themeService.setAppTheme(false);
    this.close();
    this.gotToPage("");
  }

  gotToPage(page: string) {
    this.navCtrl.navigateRoot(page);
    this.close();
  }

}
